import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import RedirectComponent from 'components/Redirect';
import { createStructuredSelector } from 'reselect';
import CommonHeader from 'components/CommonHeader';
import { makeSelectAuth, makeSelectIsMobile } from 'containers/App/selectors';
import { logout, toggleSettings } from 'containers/UserDropDown/actions';
import ReferrerPendingVerification from 'containers/ReferrerPendingVerification';
import ReferrerDashboard from 'containers/ReferrerDashboard';
import ReferrerPatientView from 'containers/ReferrerPatientView';

function Referrer({ auth, match, isMobile, logout, toggleSettings, ...rest }) {
	if (!auth || !auth.isLoggedIn) {
		return null;
	}

	const { loggedInUser } = auth;
	const headerHeight = isMobile ? 60 : 100;

	return (
		<div>
			<div style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
				<CommonHeader
					routeProps={{ ...rest, auth, isMobile, match }}
					user={loggedInUser}
					type="referrer"
					isMobile={isMobile}
					logout={logout}
					toggleSettings={toggleSettings}
					height={headerHeight}
				/>
			</div>
			{!loggedInUser.isVerified ? (
				<ReferrerPendingVerification />
			) : (
				<div className="container-fluid">
					<div className="row">
						<div className="col p-0">
							<Switch>
								<Route path="/referrer/dashboard/patient/:patientId" component={ReferrerPatientView} />
								<Route exact path="/referrer/dashboard" component={ReferrerDashboard} />
								<Route component={() => <RedirectComponent redirectPath="/referrer/dashboard" />} />
							</Switch>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	auth: makeSelectAuth(),
	isMobile: makeSelectIsMobile(),
});

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		logout: () => dispatch(logout()),
		toggleSettings: () => dispatch(toggleSettings()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Referrer);
